// Collapsed-view allowlist for the Office Software section. Figma pins these
// six as the "popular" row; the full catalog (including these) comes from
// `state.user.officeEducation.softwares`. If the BE stops returning any of
// these, the collapsed row just renders fewer pills.
// Names mirror the BE `softwares` catalog exactly (case-sensitive — the
// collapsed filter uses `Set.has`, so "EagleSoft" ≠ "Eaglesoft").
export const POPULAR_SOFTWARES = [
  'Dentrix',
  'EagleSoft',
  'Open Dental',
  'Dexis',
  'Denticon',
  'SOFTDENT',
];

export const PROFESSIONAL_RADIUS_MILES = 25;
